import React from "react";
import Box from "@mui/material/Box";
import LoginComponent from "../components/LoginComponent";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = ({ token, role, userId }) => {
    login({ token, role, userId });

    navigate(role === "admin" ? "/dashboard" : "/places");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <LoginComponent onLogin={handleLogin} />
    </Box>
  );
};

export default Login;
